/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const Journey = () => {
  const theme = useTheme();

  const items = [
    {
      title: 'TNO Network (Producción Premium)',
      description:
        'Tu mensaje en lenguaje audiovisual corporativo. Integramos producción de alto estándar y narrativa estratégica para que tu imagen proyecte la solidez y confiabilidad de tu organización.',
    },
    {
      title: 'TNO Digest (La Huella Digital)',
      description:
        'Tu entrevista se transforma en contenido editorial especializado. Aparece en nuestra selección curada de noticias para que tu visión sea consultada por miles de profesionales.',
    },
    {
      title: 'On-Demand (Presencia Permanente)',
      description:
        'Tu intervención queda alojada en nuestra plataforma para que tus clientes y aliados la consulten en cualquier momento, desde cualquier lugar.',
    },
  ];

  return (
    <Box mt={8}>
      <Typography
        variant="h5"
        component="h2"
        align="center"
        gutterBottom
        sx={{ fontWeight: 700 }}
      >
        El ecosistema de impacto
      </Typography>
      <Typography
        variant="body1"
        color="textSecondary"
        align="center"
        sx={{ maxWidth: 900, mx: 'auto', mb: 4 }}
      >
        La entrevista no termina cuando se apagan las luces. Desde el set hasta
        el entorno digital, diseñamos un recorrido para que tu mensaje evolucione,
        se multiplique y permanezca.
      </Typography>

      <Grid container spacing={3}>
        {items.map((item) => (
          <Grid item xs={12} md={4} key={item.title}>
            <Card
              elevation={3}
              sx={{
                height: '100%',
                borderRadius: 3,
                bgcolor:
                  theme.palette.mode === 'dark'
                    ? 'background.default'
                    : 'background.paper',
              }}
            >
              <CardContent>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 700, mb: 1 }}
                >
                  {item.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Journey;

